import React from "react";
import PropTypes from "prop-types";
import { ReachMenuItem, ReachMenuLink } from "./menu-button-pieces";
import Icon from "./icon";

const ActionsMenuItem = ({ option, setMountedItem }) => {
  const content = (
    <>
      {option.icon && (
        <Icon
          icon={option.icon}
          iconKit={option.iconKit}
          style={option.iconStyle}
          className="et--actions-menu--menu-icon"
        />
      )}
      <div>
        <div className="et--actions-menu--menu-option-label">{option.label}</div>
        {option.description ? (
          <div className="et--actions-menu--menu-option-description">{option.description}</div>
        ) : null}
      </div>
    </>
  );

  return option.href ? (
    <ReachMenuLink
      disabled={option.disabled}
      className="et--actions-menu--menu-option is-link"
      as={option.as}
      href={option.href}
      target={option.target}
      title={option.title}
    >
      {content}
    </ReachMenuLink>
  ) : (
    <ReachMenuItem
      disabled={option.disabled}
      title={option.title}
      className="et--actions-menu--menu-option is-button"
      onSelect={() => {
        if (typeof option.mountOnClick === "function") {
          setMountedItem(
            option.mountOnClick({
              is_open: true,
              close: () => setMountedItem(null),
            })
          );
        } else {
          option.onClick();
        }
      }}
    >
      {content}
    </ReachMenuItem>
  );
};

ActionsMenuItem.defaultProps = {
  iconKit: "gt",
};

ActionsMenuItem.propTypes = {
  setMountedItem: PropTypes.func.isRequired,
  option: PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.string,
    iconKit: PropTypes.string,
    iconStyle: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    as: PropTypes.string,
    target: PropTypes.string,
    mountOnClick: PropTypes.func,
    onClick: PropTypes.func,
  }).isRequired,
};

export default ActionsMenuItem;
